<template>

  <m-card518 :image="content.thumbnail" :alt="content.title">

    <div class="title-description-518 col-9 text-right">

      <div class="card-item-title row mx-auto justify-content-start">
        <h3 class="item-title-1 font-weight-bold text-dark" href="">{{ contentSlicer(content.title, 40) }}</h3>
        <h4 class="item-title-description col-12">{{ contentKeywords(content) }}</h4>
      </div>
    </div>
    <div class="card-item-body">

      <p class="card-body-description-518 text-dark " href="#" v-html="contentSlicer(content.body,200)"></p>

    </div>
    <div class="card-footer-518 col-12 text-left">
      <div class="show-more-item-518 ">
              <span class="show-service-text">
                اطلاعات بیشتر
              </span>
        <a class="show-more-item-icon mx-2">
          <i class="bi bi-arrow-left"></i>
        </a>
      </div>
    </div>

  </m-card518>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard518 from "../../Cards/Card518";
import mA from '../../Tags/A'
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";


export default {
  name: "ContentCard503",
  components: {mCard518, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  },
  methods: {
    contentSlicer,
    contentKeywords(content) {
      let result = ''

      content.keywords.forEach(item => {
        result += item.keyword + ' '
      })

      return result
    }
  },
  mounted() {

  }

}
</script>

<style scoped>

.item-title-1 {
  line-height: 1.6rem;
  font-size: 0.9rem;
  font-weight: bold;


}

.card-footer-518 {
  position: absolute;
  bottom: 20px;


}

.item-title-description {
  font-size: 0.9rem;
  font-weight: lighter;
  line-height: 1.8rem;
  color: gray;


}

.card-item-body {
  margin: 14px 24px 0px 24px;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  text-align: justify;
}

.show-more-item-icon {
  padding: 20px 20px 23px 23px;
  background: linear-gradient(214deg, #F6F8FB 12.49%, rgba(245, 248, 252, 0.00) 60.16%);
  border-radius: 50%;
  cursor: pointer;
}

</style>